import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type { CreateProductAutomationRequestDto } from "../../dtos/create-product-automation-request-dto";
import type { CreateProductAutomationResponseDto } from "../../dtos/create-product-automation-response-dto";
import { ProductService } from "../../services/product-service";

type UsePutUpdateProductAutomationMutationParams = {
  options?: UseMutationOptions<
    CreateProductAutomationResponseDto,
    unknown,
    CreateProductAutomationRequestDto
  >;
};

export const usePutUpdateProductAutomationMutation = ({
  options
}: UsePutUpdateProductAutomationMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.updateProductAutomation({ payload });
    },
    ...options
  });
};
